module.exports = __webpack_public_path__ + "979b35293fb513630b5e85b42c6b5a59.svg";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/Fantasque/FantasqueSansMono-Bold.svg
// module id = 418
// module chunks = 0